import {useCookies} from "react-cookie";
import {useState} from "react";

const useCookiesHook = () => {
    const [cookiesName, setCookieName] = useState();
    const [cookies, setCookie, removeCookie] = useCookies(cookiesName);
    return {setCookieName, cookies, setCookie, removeCookie};
}

export default useCookiesHook;